import type { ChangeEventHandler, ReactNode } from "react";
import type React from "react";
import { forwardRef, useId } from "react";

import classnames from "classnames";

import styles from "./RadioCard.module.scss";

export type RadioCardProps = {
  value: string | number;
  title: React.ReactNode;
  groupName: string;
  inputId?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  isUnavailable?: boolean;
  isDisabled?: boolean;
  subtitle?: string;
  description?: string | ReactNode;
  icon?: React.ReactElement;
  type?: "radio" | "checkbox";
  isChecked?: boolean;
};

export const RadioCard = forwardRef<HTMLInputElement, RadioCardProps>(
  (
    {
      value,
      title,
      groupName,
      inputId,
      subtitle,
      description,
      icon,
      isDisabled = false,
      isUnavailable = false,
      onChange,
      type = "radio",
      isChecked,
    },
    ref
  ) => {
    const ownId = useId();
    const idToUse = inputId ?? ownId;

    return (
      <div className={styles.container}>
        <input
          value={value}
          ref={ref}
          name={groupName}
          onChange={onChange}
          disabled={isDisabled}
          id={idToUse}
          className={styles.radioInput}
          type={type}
          checked={isChecked}
        />
        <label
          className={classnames(styles.radioLabel, {
            [styles.isUnavailable]: isUnavailable,
            [styles.isDisabled]: isDisabled,
          })}
          htmlFor={idToUse}
        >
          <div className={styles.radioBox}>
            {icon ? <div className={styles.radioIcon}>{icon}</div> : null}
            <div className={styles.radioTitleBox}>
              <span className={styles.radioTitle}>{title}</span>
              {subtitle ? <span className={styles.radioSubtitle}>{subtitle}</span> : null}
            </div>
          </div>

          {description ? <div className={styles.radioDescription}>{description}</div> : null}
        </label>
      </div>
    );
  }
);
